import React from "react";
import { PDFViewer, Document, Page, View, Text, Image, Link } from "@react-pdf/renderer";
import {styles} from "./style";
import logo from "../../assets/primaryLogo.png";
import { useSelector } from "react-redux";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { theme } from "../../styles/styles";
import HtmlText from "./html-parser";

export default function PDF() {
    const inputs = useSelector((state) => state.inputs.value);
    const chartImage = sessionStorage.getItem('chartImage');
    const incentivesApplied = useSelector((state) => state.inputs.value.incentives).filter(incentive => incentive.applied);
    const benefitToResident = useSelector((state) => state.inputs.value.benefitToResident)*10;
    const monthlyBuildingBenefit = useSelector((state) => state.outputs.value.roi.monthlyBuildingBenefit);
    const rateArray = useSelector((state) => state.outputs.value.roi.rateArray);
    const markupArray = useSelector((state) => state.outputs.value.roi.markupArray);
    const yearsToBreakEven = useSelector((state) => state.outputs.value.roi.yearsToBreakEven);
    const netROI10Year = useSelector((state) => state.outputs.value.roi.netROIWithNegatives);
    const roiArray = useSelector((state) => state.outputs.value.roi.roiArray);
    const monthlyResidentBenefit = useSelector((state) => state.outputs.value.roi.monthlyResidentBenefit);
    const advancedConfigFields = useSelector((state) => state.inputs.advancedConfigToShow);
   

    const propertyDetails = [
        {
            title: "Property Status",
            // icon:
            value: inputs.newDevelopment ? "New Development" : "Existing Property"
        },
        {
            title: "Type of Housing",
            // icon:
            value: inputs.propertyType
        },
        {
            title: "Parking Configuration",
            // icon:
            value: inputs.parkingConfig
        },
        {
            title: "Construction Year",
            // icon:
            value: inputs.yearBuilt
        },
        {
            title: "Number of Units",
            // icon:
            value: inputs.units
        },
        {
            title: inputs.parkingConfig === "Mixed" ? "Number of First Come First Served Spaces" : "Number of Parking Spaces",
            // icon:
            value: inputs.parkingSpaces
        },
        ...(inputs.parkingConfig === "Mixed" ? [{
            title: "Number of Assigned Spaces",
            // icon:
            value: inputs.assignedParkingSpaces
        }] : []),
        {
            title: inputs.parkingConfig === "Mixed" ? "Number of First Come First Served Spaces to Electrify" : "Number of Parking Spaces to Electrify",
            // icon:
            value: inputs.parkingSpacesToElectrify
        },
        ...(inputs.parkingConfig === "Mixed" ? [{
            title: "Number of Assigned Spaces to Electrify",
            // icon:
            value: inputs.assignedParkingSpacesToElectrify
        }] : []),
        {
            title: "Address",
            // icon:
            value: inputs.streetAddress
        },
        {
            title: "State",
            // icon:
            value: inputs.state
        },
    ]

    // Create Document Component
    const OutputPDF = () => (
        <Document title="Charge at Home Project Builder Report" author="Charge at Home">
            <Page size="A4" style={styles.page}>
                <View style={styles.header}>
                        <Link href="https://chargeathome.org/" target="_blank"> 
                            <Image src={logo} style={styles.logo}></Image>
                        </Link>
                    <View style={styles.innerHeader}>
                        <Text>Charge at Home</Text>
                        <Text>Project Builder</Text>
                    </View>
                </View>
                <View style={styles.mainPage}>
                    <Text style={styles.titleText}>Property Details</Text>
                    <View style={styles.grid}>
                        {propertyDetails.map((item, index) => (
                            <View key={index} style={styles.gridItem}>
                                <Text style={styles.gridTitle}>{item.title}</Text>
                                <Text style={styles.gridValue}>{item.value}</Text>
                            </View>
                        ))}
                    </View>
                </View>
                { incentivesApplied.length > 0 || (chartImage !== null && chartImage !== 'null') ? <>
                <View break>
                    <View style={styles.header}>
                            <Link href="https://chargeathome.org/" target="_blank"> <Image src={logo} style={styles.logo}></Image></Link>
                        <View style={styles.innerHeader}>
                            <Text>Charge at Home</Text>
                            <Text>Project Builder</Text>
                        </View>
                    </View>
                    <View style={styles.mainPage}>
                        {chartImage ? <><Text style={styles.titleText}>Revenue Overview</Text> <Image src={chartImage}></Image> </>: null}
                        {incentivesApplied.length > 0 ? (<Text style={styles.titleText}>Incentives Applied</Text>) : null}
                            {incentivesApplied.map((incentive, index) => (
                                 <View key={index} style={styles.incentiveContainer} wrap={false}>
                                          {incentive.Link ? <Link href={incentive.Link}
                                             target="_blank"
                                             style={styles.incentiveTitle}
                                          >
                                             <Text style={styles.incentiveTitle}>{incentive.Title}</Text>
                                          </Link> : <Text style={styles.incentiveTitle}>{incentive.Title}</Text>}
                                       <View style={styles.incentiveBody}>
                                       <Text style={styles.incentiveBodyLine}>Estimated Amount for Project: {incentive.amountApplied ? `$${incentive.amountApplied.toLocaleString(undefined, {maximumFractionDigits: 0})}`: 'Unknown'}</Text>
                                       <Text style={styles.incentiveBodyLine}>Source: {incentive.Type === "State"  ? "State of " + incentive.State : incentive.Type === "Utility" ? incentive.Utility : incentive.Type}</Text>
                                       <Text style={styles.incentiveBodyLine}>{incentive["Plain Text"]}</Text>
                                    </View>
                                 </View>
                            ))}
                        </View>
                    </View></> : null }
                    <View break>
                        <View style={styles.header}>
                            <Link href="https://chargeathome.org/" target="_blank"> <Image src={logo} style={styles.logo}></Image></Link>
                            <View style={styles.innerHeader}>
                                <Text>Charge at Home</Text>
                                <Text>Project Builder</Text>
                            </View>
                        </View>
                        <View style={styles.mainPage}>
                            <Text style={styles.titleText}>Revenue Calculations</Text>
                            <Text style={[styles.subheader, {color: theme.voltBlue}]}>One-Time</Text>
                            <View style={[styles.grid, {marginTop: '2px', borderColor: theme.voltBlue}]} wrap={false}>
                                <View style={styles.calculationSection}>
                                    <View style={styles.calculationTitle}>
                                        <Text style={[styles.calculationTitleText, {color: '#9D0909'}]}>Costs</Text>
                                    </View>
                                    <View style={styles.calculationList}>
                                        {inputs.costOneTimeArr.map((cost, index) => (
                                            <View key={index} style={[styles.gridItem, {borderBottom: (index == inputs.costOneTimeArr.length - 1) ? 'none' : null}]}>
                                                <Text style={[styles.calculationLabel, {color: '#9D0909'}]}>{cost.title}</Text>
                                                <Text style={[styles.calculationNumber, {color: '#9D0909'}]}>-${cost.amount.toLocaleString(undefined, {maximumFractionDigits: 0})}</Text>
                                            </View>
                                        ))}
                                    </View>
                                </View>
                                {incentivesApplied.length > 0 ?
                                (<View style={styles.calculationSection}>
                                    <View style={styles.calculationTitle}>
                                        <Text style={styles.calculationTitleText}>Incentives</Text>
                                    </View>
                                    <View style={styles.calculationList}>
                                        {incentivesApplied.map((incentive, index) => (
                                            <View key={index} style={[styles.gridItem, {borderBottom: (index == incentivesApplied.length - 1) ? 'none' : null}]}>
                                                <Text style={styles.calculationLabel}>{incentive.Title}</Text>
                                                <Text style={styles.calculationNumber}>+${incentive.amountApplied.toLocaleString(undefined, {maximumFractionDigits: 0})}</Text>
                                            </View>
                                        ))}
                                    </View>
                                </View>) : null}
                                <View style={[styles.calculationSection, {borderTop: 'none', borderBottom: 'none'}]}>
                                    <View style={styles.calculationTitle}>
                                        <Text style={[styles.calculationTitleText, {color: theme.voltBlue}]}>Total</Text>
                                    </View>
                                    <View style={[styles.calculationList, {borderTop: 'none'}]}>
                                        <View style={[styles.gridItem, {borderTopWidth: 0, borderColor: theme.evTeal, borderBottom: 'none'}]}>
                                            <Text style={[styles.calculationLabel]}></Text>
                                            <Text style={[styles.calculationNumber, {color: theme.voltBlue}]}> {parseInt((incentivesApplied.reduce((acc, incentive) => acc + incentive.amountApplied, 0)) - parseInt(inputs.costOneTimeArr.reduce((acc, cost) => acc + cost.amount, 0))).toLocaleString('en-US', {maximumFractionDigits: 0, style: 'currency', currency: 'USD'})}</Text>

                                        </View>
                                    </View>
                                </View>
                            </View>
                            <Text style={styles.subheader}>Recurring (Annual)</Text>
                            <View style={[styles.grid, {marginTop: '2px', borderColor: theme.voltBlue}]} wrap={false}>
                                {inputs.costMonthlyArr.length > 0 ? (
                                <View style={styles.calculationSection}>
                                    <View style={styles.calculationTitle}>
                                        <Text style={[styles.calculationTitleText, {color: '#9D0909'}]}>Costs</Text>
                                    </View>
                                    <View style={styles.calculationList}>
                                        {inputs.costMonthlyArr.map((cost, index) => (
                                            <View key={index} style={[styles.gridItem, {borderBottom: (index == inputs.costMonthlyArr.length - 1) ? 'none' : null}]}>
                                                <Text style={[styles.calculationLabel, {color: '#9D0909'}]}>{cost.title}</Text>
                                                <Text style={[styles.calculationNumber, {color: '#9D0909'}]}>-${(cost.amount*12).toLocaleString(undefined, {maximumFractionDigits: 0})}</Text>
                                            </View>
                                        ))}
                                    </View>
                                </View>) : null}
                                <View style={styles.calculationSection}>
                                    <View style={styles.calculationTitle}>
                                        <Text style={[styles.calculationTitleText]}>Revenue</Text>
                                    </View>
                                    <View style={styles.calculationList}>
                                        {inputs.roiAnnualArr.map((revenue, index) => (
                                            <View key={index} style={[styles.gridItem]}>
                                                <Text style={[styles.calculationLabel]}>{revenue.title}</Text>
                                                <Text style={[styles.calculationNumber]}>+${revenue.amount.toLocaleString(undefined, {maximumFractionDigits: 0})}</Text>
                                            </View>
                                        ))}
                                        {inputs.roiMonthlyArr.map((revenue, index) => (
                                            <View key={index} style={[styles.gridItem]}>
                                                <Text style={[styles.calculationLabel]}>{revenue.title}</Text>
                                                <Text style={[styles.calculationNumber]}>+${(revenue.amount*12).toLocaleString(undefined, {maximumFractionDigits: 0})}</Text>
                                            </View>
                                        ))}
                                        <View style={[styles.gridItem, {borderBottom: 'none'}]}>
                                            <Text style={[styles.calculationLabel]}>Charging Profit</Text>
                                            <Text style={[styles.calculationNumber]}>+${(monthlyBuildingBenefit[benefitToResident]*12).toLocaleString(undefined, {maximumFractionDigits: 0})}</Text>
                                        </View>
                                    </View>
                                </View>
                                <View style={[styles.calculationSection, {borderTop: 'none', borderBottom: 'none'}]}>
                                    <View style={styles.calculationTitle}>
                                        <Text style={[styles.calculationTitleText, {color: theme.voltBlue}]}>Total</Text>
                                    </View>
                                    <View style={[styles.calculationList, {borderTop: 'none'}]}>
                                        <View style={[styles.gridItem, {borderTopWidth: 0, borderColor: theme.evTeal, borderBottom: 'none'}]}>
                                            <Text style={[styles.calculationLabel]}></Text>
                                            <Text style={[styles.calculationNumber, {color: theme.voltBlue}]}> {parseInt(
                                                inputs.roiAnnualArr.reduce((acc, incentive) => acc + incentive.amount, 0) +
                                                inputs.roiMonthlyArr.reduce((acc, incentive) => acc + incentive.amount*12, 0) +
                                                monthlyBuildingBenefit[benefitToResident]*12 -
                                                inputs.costMonthlyArr.reduce((acc, cost) => acc + cost.amount*12, 0)
                                            ).toLocaleString('en-US', {maximumFractionDigits: 0, style:'currency', currency:'USD'})}</Text>

                                        </View>
                                    </View>
                                </View>
                            </View>
                            <View wrap={false}>
                                <Text style={styles.subheader}>Outcomes</Text>
                                <View style={[styles.grid, {marginTop: '2px', borderColor: theme.voltBlue}]}>
                                    <View style={[styles.calculationSection, {borderBottom: 'none'}]}>
                                        <View style={styles.calculationTitle}>
                                            <Text style={[styles.calculationTitleText, {color: theme.voltBlue}]}>Benefits</Text>
                                        </View>
                                        <View style={[styles.calculationList, {borderBottom: 'none'}]}>
                                            <View style={[styles.gridItem, {borderBottom: 'none'}]}>
                                                <Text style={[styles.calculationLabel, {color: theme.voltBlue, fontWeight: 'bold', width: '175px'}]}>Total ROI Over 10 Years (Discounted)</Text>
                                                <Text style={[styles.calculationNumber, {color: theme.voltBlue, fontWeight: 'bold'}]}>{roiArray[benefitToResident].toLocaleString('en-US', {maximumFractionDigits: 0, style: 'currency', currency: 'USD'})}</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </View>
                    {/* </View> */}
                    <View break>
                        <View style={styles.header}>
                            <Link href="https://chargeathome.org/" target="_blank"> <Image src={logo} style={styles.logo}></Image></Link>
                            <View style={styles.innerHeader}>
                                <Text>Charge at Home</Text>
                                <Text>Project Builder</Text>
                            </View>
                        </View>
                        <View style={styles.mainPage}>
                            <Text style={styles.titleText}>Revenue Details</Text>
                            <Text style={[styles.incentiveBody, {paddingLeft: 'none'}]}>Revenue by default is coming from the cost difference of charging at home vs. at public DC fast charger stations. 
                                The values of at home charging are average commercial charging rates, inclusive of fees such as demand charges. 
                                You have selected to charge EV drivers <Text style={styles.boldText}>${(rateArray[10 - benefitToResident]).toLocaleString(undefined, {minimumFractionDigits: 2})}</Text> per kWh. 
                                This equates to a mark-up of <Text style={styles.boldText}>{(markupArray[10 - benefitToResident]*100).toLocaleString(undefined, {maximumFractionDigits: 0})}% </Text>
                                on the average commercial rate (estimated here as <Text style={styles.boldText}>${rateArray[0].toLocaleString(undefined, {minimumFractionDigits: 2})}</Text> per kWh), 
                                which will result in the following outcomes.</Text>
                            <Text style={[styles.incentiveBody, {paddingLeft: 'none', paddingTop: '10px'}]}><Text style={styles.boldText}>Please note: </Text>When showing ROI throughout this document, we use the discounted ROI. 
                                This means future revenue is adjusted to reflect the time value of money. You can adjust the discount rate in the advanced configurations on the Project Builder tool.</Text>
                            <View style={styles.grid}>
                                <View style={styles.gridItem}>
                                    <Text style={styles.gridTitle}>{inputs.parkingConfig !== 'Mixed' ? 'Parking Spaces to Electrify': 'First Come, First Served Parking Spaces to Electrify'}</Text>
                                    <Text style={styles.gridValue}>{inputs.parkingSpacesToElectrify}</Text>
                                </View>
                                { inputs.parkingConfig === 'Mixed' ? (
                                    <View style={styles.gridItem}>
                                        <Text style={styles.gridTitle}>Assigned Parking Spaces to Electrify</Text>
                                        <Text style={styles.gridValue}>{inputs.assignedParkingSpacesToElectrify}</Text>
                                    </View>
                                ) : null }
                                <View style={[styles.gridItem, {borderBottom: 'none'}]}>
                                    <Text style={[styles.gridTitle, {color: theme.voltBlue}]}>Discounted ROI Per Space Over 10 Years</Text>
                                    <Text style={[styles.gridValue, {color: theme.voltBlue}]}>${((roiArray[benefitToResident])/(inputs.parkingSpacesToElectrify + (inputs.parkingConfig === 'Mixed' ? inputs.assignedParkingSpacesToElectrify : 0))).toLocaleString(undefined, {maximumFractionDigits: 0})}</Text>
                                </View>
                            </View>
                            <View style={styles.grid}>
                                <View style={styles.gridItem}>
                                    <Text style={styles.gridTitle}>Years to Break Even</Text>
                                    <Text style={styles.gridValue}>{yearsToBreakEven[benefitToResident].toLocaleString(undefined, {maximumFractionDigits: 1})}</Text>
                                </View>
                                <View style={styles.gridItem}>
                                    <Text style={[styles.gridTitle]}>Net ROI Over {inputs.roiPeriod} Years</Text>
                                    <Text style={[styles.gridValue]}>{`${netROI10Year[benefitToResident].toLocaleString(undefined, {maximumFractionDigits: 0})}%`}</Text>
                                </View>
                                <View style={styles.gridItem}>
                                    <Text style={[styles.gridTitle]}>Estimated Monthly Benefit to Property Owners</Text>
                                    <Text style={[styles.gridValue]}>${monthlyBuildingBenefit[benefitToResident].toLocaleString(undefined, {maximumFractionDigits: 0})}</Text>
                                </View>
                                <View style={[styles.gridItem, {borderBottom: 'none'}]}>
                                    <Text style={[styles.gridTitle]}>Estimated Monthly Benefit to Residents</Text>
                                    <Text style={[styles.gridValue]}>${monthlyResidentBenefit[benefitToResident].toLocaleString(undefined, {maximumFractionDigits: 0})}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View break>
                        <View style={styles.header}>
                            <Link href="https://chargeathome.org/" target="_blank"> <Image src={logo} style={styles.logo}></Image></Link>
                            <View style={styles.innerHeader}>
                                <Text>Charge at Home</Text>
                                <Text>Project Builder</Text>
                            </View>
                        </View>
                        <View style={styles.mainPage}>
                            <Text style={styles.titleText}>Advanced Configurations</Text>
                            <View style={styles.advancedConfigGrid}>
                                <View style={[styles.advancedConfigGridItem, {borderTop: 'none'}]}>
                                    <Text style={[styles.advancedConfigBox, {width: '21%', color: theme.evTeal, borderLeft: 'none'}]}>Configuration</Text>
                                    <Text style={[styles.advancedConfigBox, {width: '12%', color: theme.evTeal}]}>Value</Text>
                                    <Text style={[styles.advancedConfigBox, {width: '15%', color: theme.evTeal}]}>Units</Text>
                                    <Text style={[styles.advancedConfigBox, {width: '13%', color: theme.evTeal}]}>Range</Text>
                                    <Text style={[styles.advancedConfigBox, {width: '40%', color: theme.evTeal}]}>Definition</Text>
                                </View>
                                {advancedConfigFields.slice(0,6).map((item, index) => (
                                    <View key={index} style={styles.advancedConfigGridItem}>
                                       <Text style={[styles.advancedConfigBox, {width: '21%', borderLeft: 'none'}]}>{item.placeholder}</Text>
                                        <Text style={[styles.advancedConfigBox, {width: '12%'}]}>{item.id === 'annualVehiclesMiles' ? item.defaultValue.toLocaleString('en') : item.defaultValue}</Text>
                                        <Text style={[styles.advancedConfigBox, {width: '15%'}]}>{item.units}</Text>
                                        <Text style={[styles.advancedConfigBox, {width: '13%'}]}>{item.range[0].toLocaleString('en')} to {item.range[1].toLocaleString('en')}</Text>
                                        <HtmlText html={item.text} style={[styles.advancedConfigBox, { width: '40%' }]} />
                                    </View>
                                ))}
                            </View>
                        </View>
                    </View>
                    <View break>
                        <View style={styles.header}>
                            <Link href="https://chargeathome.org/" target="_blank"> <Image src={logo} style={styles.logo}></Image></Link>
                            <View style={styles.innerHeader}>
                                <Text>Charge at Home</Text>
                                <Text>Project Builder</Text>
                            </View>
                        </View>                    
                        <View style={styles.mainPage}>
                            <View style={styles.advancedConfigGrid}>
                                {advancedConfigFields.slice(6, advancedConfigFields.length).map((item, index) => (
                                    <View key={index} style={[styles.advancedConfigGridItem, {borderTop: index === 0 ? 'none' : '1px solid #e0e0e0'}]}>
                                       <Text style={[styles.advancedConfigBox, {width: '21%', borderLeft: 'none'}]}>{item.placeholder}</Text>
                                        <Text style={[styles.advancedConfigBox, {width: '12%'}]}>{item.id === 'annualVehiclesMiles' ? item.defaultValue.toLocaleString('en') : item.defaultValue}</Text>
                                        <Text style={[styles.advancedConfigBox, {width: '15%'}]}>{item.units}</Text>
                                        <Text style={[styles.advancedConfigBox, {width: '13%'}]}>{item.range[0].toLocaleString('en')} to {item.range[1].toLocaleString('en')}</Text>
                                        <HtmlText html={item.text} style={[styles.advancedConfigBox, { width: '40%' }]} />
                                    </View>
                                ))}
                            </View>
                            <Text style={{fontSize: '0.75rem', marginTop: '10px'}}>To adjust your model and read about our methodology, please visit the <Link href='https://projectbuilder.chargeathome.org/'>Charge at Home Project Builder</Link>.</Text>
                        </View>
                    </View>
                </View>
                </Page>
        </Document>
    );


    return (
        <div className="w-full-h-[750px]">
            <PDFViewer style={{ width: "100%", height: "100vh" }}>
                <OutputPDF />
            </PDFViewer>
        </div>
    );
}